/** Tokens visuais — compartilhar evento (mesmo padrão dos recebimentos) */
export const COMPARTILHAR_ACCENT = "#F96030";
export const COMPARTILHAR_INK = "#1a2035";
export const COMPARTILHAR_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const compartilharToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${COMPARTILHAR_ACCENT}`,
};

export const compartilharSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const compartilharFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
    minHeight: 44,
  },
};
